import React from "react";
import Service from '../../service/Service';
import * as actions from '../Actions';
// import downarr from '../../assets/images/due_date/due_date_down_arrow.svg';

const service = new Service();

export default function DisclaimerReferences({eleRef}) {
    return (
        <div>
            
            <div className="duedate-btn-block" id="due_disclaimer">
                {/* <div className="duedate-question faqdiscl-title" id="disc" onClick={() => { actions.duDateQans("disc") }}>
                    <div id="disc" className="faqdiscl left B18_21">Disclaimer</div>
                    <span className="arrow-down icon downicon" data-icon-font="f" style={{display:"none"}}></span>
                    <span className="arrow-up icon upicon" data-icon-font="n" style={{display:"block"}}></span>
                </div> */}
                <div className="faq-dropdwn" style={{display:"block"}}>
                    <div className="duedate-disclaimer">
                        <div className="disclaimer-title">
                            <h3>
                                <span className="M17_42">Disclaimer :</span>
                            </h3>
                        </div>
                        <div className="disclaimer-content">
                            <span className="R14_61"> Firstcry Parenting - Due Date Calculator determines the probable due date. Only your physician/Doctor can accurately determine your due date based on his/her knowledge of your medical history. All the calculations are tentative and Firstcry won’t be responsible for any related consequences.
                        </span>
                        </div>
                        <div className="disclaimer-title reference_title">
                            <h3>
                                <span className="M17_42">References :</span>
                            </h3>
                        </div>
                        <div className="disclaimer-content">
                            <div className="ref_point_wrap">
                                1. Pregnancy - signs and symptoms; Better Health Channel; 
                                <div className="ref_link">
                                    <a href="https://www.betterhealth.vic.gov.au/health/healthyliving/pregnancy-signs-and-symptoms">https://www.betterhealth.vic.gov.au/health/healthyliving/pregnancy-signs-and-symptoms</a>
                                </div>
                            </div>
                            <div className="ref_point_wrap">
                                2. Doing a pregnancy test; NHS;
                                <div className="ref_link">
                                    <a href="https://www.nhs.uk/pregnancy/trying-for-a-baby/doing-a-pregnancy-test/">https://www.nhs.uk/pregnancy/trying-for-a-baby/doing-a-pregnancy-test/</a>
                                </div>
                            </div>
                             <div className="ref_point_wrap">
                                3. Pregnancy Due Date Calculator; American Pregnancy Association;
                                <div className="ref_link">
                                    <a href="https://americanpregnancy.org/resources/pregnancy-calculator/">https://americanpregnancy.org/resources/pregnancy-calculator/</a>
                                </div>
                            </div>
                             <div className="ref_point_wrap">
                                4. Gestational Age vs Fetal Development – What is the Difference?; Kinsey Institiute Research & Institue News;
                                <div className="ref_link">
                                    <a href="https://blogs.iu.edu/kinseyinstitute/2023/05/26/gestational-age-vs-fetal-development-what-is-the-difference/">https://blogs.iu.edu/kinseyinstitute/2023/05/26/gestational-age-vs-fetal-development-what-is-the-difference/</a>
                                </div>
                            </div>
                             <div className="ref_point_wrap">
                                5. Gestational age; MedlinePlus;
                                <div className="ref_link">
                                    <a href="https://medlineplus.gov/ency/article/002367.htm">https://medlineplus.gov/ency/article/002367.htm</a>
                                </div>
                            </div>
                             <div className="ref_point_wrap">
                                6. Due date calculator; NHS;
                                <div className="ref_link">
                                    <a href="https://www.nhs.uk/pregnancy/finding-out/due-date-calculator/">https://www.nhs.uk/pregnancy/finding-out/due-date-calculator/</a>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
